import { defineMessages } from "react-intl";

/**
 * Shared connector labels used by the extracted side-panel flows. These are
 * defined under shared-ui's own `shared-ui:` id namespace because the repo's
 * translation tooling requires each message id to have a single owning package
 * (see `bin/compile-translations.mjs` duplicate-key check). funding-application
 * keeps its own COMMON_MESSAGES for the labels its non-connector code still uses.
 */
export const COMMON_MESSAGES = defineMessages({
  connectAccount: {
    id: "shared-ui: connect account",
    defaultMessage: "Connect Account",
  },
  connected: {
    id: "shared-ui: connected",
    defaultMessage: "Connected",
  },
  addAnother: {
    id: "shared-ui: add another",
    defaultMessage: "Add another",
  },
  notConnected: {
    id: "shared-ui: not connected",
    defaultMessage: "Not connected",
  },
  reconnectAction: {
    id: "shared-ui: reconnect action",
    defaultMessage: "Reconnect",
  },
});
